import "./FooterPublicTwo.scss";
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import logoFooter from "../../../styles/images/silla-naranja.svg";
import Icon from "../../Icon/Icon";
import InputText from "../../DesingSystem/InputText/InputText";
import CheckBox from "../../DesingSystem/CheckBox/CheckBox";
import { postApiNewsletterSubscribe } from "../../../services/apiBundle";

function FooterPublic() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [subscribeMessage, setSubscribeMessage] = useState("");
  const [subscribeErrorMessage, setSubscribeErrorMessage] = useState("");
  const [isEmailEntered, setIsEmailEntered] = useState(false);
  const [tosAccepted, setTosAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputEmailFocus = () => {
    setIsEmailEntered(true);
  };
  const handleInputEmailBlur = () => {
    setIsEmailEntered(false);
  };

  const navigateToPath = (path) => {
    navigate(path);
  };

  const goToFb = () => {
    navigate("");
  };
  const goToIg = () => {
    navigate("");
  };
  const goToLi = () => {
    navigate("");
  };
  const goToTw = () => {
    navigate("");
  };

  const subscribeBrevo = async () => {
    // Validar que el checkbox esté marcado
    if (!tosAccepted) {
      setSubscribeErrorMessage("Debes aceptar los términos y condiciones");
      setSubscribeMessage("");
      return;
    }

    setIsLoading(true);
    setSubscribeErrorMessage("");
    setSubscribeMessage("");

    try {
      const response = await postApiNewsletterSubscribe(email);
      setSubscribeMessage(response.message || "¡Suscripción exitosa!");
      setEmail("");
      setTosAccepted(false);
    } catch (error) {
      setSubscribeErrorMessage(error.message || "Error al suscribirse");
      setSubscribeMessage("");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <section className="footer-public-two">
        <div id="logo" className="footer-public-two__section-logo">
          <img src={logoFooter} alt="Logo Bookolicos text"></img>
        </div>

        <div id="rrss" className="footer-public-two__section-rsss">
          <ul className="footer-public-two__section-rsss-list">
            {/*<li className="footer-public-two__section-rsss-list-item">
              <a href="#" target="_blank">
                <Icon
                  name="facebook"
                  size="medium2"
                  color="secondary-6"
                  background="4"
                />
              </a>
            </li>*/}
            <li
              className="footer-public-two__section-rsss-list-item"
            >
              <a href="https://instagram.com/bookolicos.es" target="_blank" title="Instagram">
                <Icon
                  name="instagram"
                  size="medium2"
                  color="secondary-6"
                  background="4"
                />
              </a>
            </li>
            <li
              className="footer-public-two__section-rsss-list-item"
            >
              <a href="https://www.linkedin.com/company/bookólicos/" target="_blank" title="Linkedin">
                <Icon
                  name="linkedin"
                  size="medium2"
                  color="secondary-6"
                  background="4"
                />
              </a>
            </li>
            {/*<li className="footer-public-two__section-rsss-list-item">
              <a href="#" target="_blank">
                <Icon
                  name="twitter"
                  size="medium2"
                  color="secondary-6"
                  background="4"
                />
              </a>
            </li>*/}
          </ul>
        </div>

        <div id="legality" className="footer-public-two__section-legality">
          <Link to="/politica-privacidad" target="_blank" title="Politica privacidad">
            <p className="footer-public-two__section-legality-text">
              Política de privacidad
            </p>
          </Link>
          <Link to="/aviso-legal" target="_blank" title="Aviso legal">
            <p className="footer-public-two__section-legality-text">Aviso legal</p>
          </Link>
          <Link to="/condiciones-generales" target="_blank" title="Condiciones compra">
            <p className="footer-public-two__section-legality-text">
              Condiciones de compra
            </p>
          </Link>
          <Link to="/terminos-condiciones" target="_blank" title="Terminos">
            <p className="footer-public-two__section-legality-text">
              Términos y condiciones
            </p>
          </Link>
          <Link to="/seguridad-producto-bookolicos.txt" target="_blank" title="Seguridad producto">
            <p className="footer-public-two__section-legality-text">
              Seguridad de producto
            </p>
          </Link>
        </div>

        <div id="input" className="footer-public-two__section-input">
          <div className="footer-public__section-input-up">
            <p
              className="footer-public-two__section-input-text"
              onClick={() => navigateToPath("/descubre")}
            >
              Catálogo
            </p>
            <p className="footer-public-two__section-input-text" onClick={() => navigateToPath("/por-que-bookolicos")}>
              ¿Por qué Bookólicos?
            </p>
            <p className="footer-public-two__section-input-text" onClick={() => navigateToPath("/quienes-somos")}>
              Quiénes somos
            </p>
          </div>
          {/*<p className="footer__section-input-text" onClick={gotToNews}>
              Noticias{" "}
              </p>*/}
          <div className="footer-public-two__section-input-down">
            <p
              className="footer-public__section-input-text"
              onClick={() => navigateToPath("/noticias")}
            >
              Blog
            </p>
            <p
              className="footer-public-two__section-input-text"
              onClick={() => navigateToPath("/faqs")}
            >
              FAQs
            </p>
            <p
              className="footer-public-two__section-input-text"
              onClick={() => navigateToPath("/contacto")}
            >
              Contacto
            </p>
          </div>
        </div>

        <div id="newsletter" className="footer-public-two__section-newsletter">
          <div className="footer-public-two__section-newsletter-input">
            <p className="footer-public-two__section-newsletter-text">
              Suscríbete a la Newsletter de Bookólicos
            </p>
            <InputText
              icon="arrowDiagonal"
              iconSize="large"
              iconColor="secondary-6"
              iconBorder="background-5"
              error={isEmailEntered}
              onFocus={handleInputEmailFocus}
              onBlur={handleInputEmailBlur}
              type="email"
              id="email"
              name="email"
              placeholder="Escribe tu email"
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              iconClick={() => {
                subscribeBrevo();
              }}
              disabled={isLoading}
            />

            {subscribeMessage && subscribeMessage !== "" ? (
              <p className="success ms-3">{subscribeMessage}</p>
            ) : null}

            {subscribeErrorMessage && subscribeErrorMessage !== "" ? (
              <p className="error ms-3">{subscribeErrorMessage}</p>
            ) : null}
            <CheckBox
              className="mt-3"
              id="stripeTOS"
              name="stripeTOS"
              label="Acepto los <a href='/politica-privacidad' target='_blank'>términos y condiciones</a>"
              hasLink={true}
              checked={tosAccepted}
              onChange={(e) => setTosAccepted(e.target.checked)}
            />
          </div>
        </div>

        <div id="copy" className="footer-public-two__section-copy">
          <small className="footer-public-two__section-copy-text">
            © {new Date().getFullYear()} Bookólicos
          </small>
        </div>
      </section>

      <div className="footer-public-two__section-cards">
        <img src="/images/medios-pago.svg" alt="cards" />
      </div>
      
      <div className="footer-public__section-cards">
        <img src="/images/logos-kitdigital-bookolicos.jpg" class="footer__section-cards__kit-digital" alt="logos kit digital" />
      </div>
    </>
  );
}

export default FooterPublic;
